export default {
  setTopTenKillers(state, payload) {
    state.topTenKillers = payload.value;
  },
  setTopTenMethods(state, payload) {
    state.topTenMethods = payload.value;
  },
  setMurderDates(state, payload) {
    state.murderDates = payload.value;
  },
  setKillerSoap(state, payload) {
    state.killerSoap = payload.value;
  },
  setMethodSoap(state, payload) {
    state.methodSoap = payload.value;
  },
  setDeadlySoap(state, payload) {
    state.deadlySoap = payload.value;
  },
  toggleMurderDetails(state) {
    state.showMurderDetails = !state.showMurderDetails;
  },
 
};
